const SET_PROFILE_IMAGE_DATA_URL = 'SET_PROFILE_IMAGE_DATA_URL'
const SET_COMPANY_PROFILE_IMAGE_DATA_URL = 'SET_COMPANY_PROFILE_IMAGE_DATA_URL'
const UPDATE_CURRENT_USER_LANGUAGE = 'UPDATE_CURRENT_USER_LANGUAGE'

export {
  SET_PROFILE_IMAGE_DATA_URL,
  SET_COMPANY_PROFILE_IMAGE_DATA_URL,
  UPDATE_CURRENT_USER_LANGUAGE,
}
